'use client';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export default function NotFoundScreen() {
  const { t } = useTranslation();

  return (
    <section className="bg-primary border border-border rounded-xl p-3.5">
      <h1 className="my-4 text-base font-normal">{t('website.notFound.message')}</h1>
      <Link
        to="/catalog"
        className="border-0 rounded-xl px-3.5 py-2.5 cursor-pointer bg-secondary text-text inline-block"
      >
        {t('website.notFound.backToCatalog')}
      </Link>
    </section>
  );
}
